import { useMemo } from 'react';
import { Divider, ListItemIcon, MenuItem, Stack, Typography } from '@mui/material';

import useMerchant from 'src/hooks/useMerchant';
import Scrollbar from 'src/components/Scrollbar';
import { BrandedCubesIcon } from 'src/theme/overrides/CustomIcons';

//
//

interface Props {
  onChange: (id: string) => void;
}

const MerchantSwitcher: React.FC<Props> = ({ onChange }) => {
  const { merchantUsers, merchant } = useMerchant();

  const getMerchantNameById = (id: string) => {
    if (merchantUsers && merchantUsers?.length > 0 && id) {
      const merchant = merchantUsers?.find((user: any) => {
        return user?.id === id;
      });
      if (merchant?.name) {
        return merchant?.name;
      }
    }
  };

  const users = useMemo(() => {
    const excludedCurrent = merchantUsers?.filter((val) => val?.id && (val.id !== merchant?.id))
    return excludedCurrent
      ?.filter((val, index) => excludedCurrent.findIndex((item) => item.id === val.id) === index)
      ?.sort((a, b) => a?.id.localeCompare(b?.id))},
  [merchantUsers, merchant]);

  //

  return (
    <>
      {merchantUsers && merchantUsers?.length > 1 && (
        <>
          <Divider sx={{ borderStyle: 'dashed' }} />

          <Typography variant="h6" sx={{ p: '0.6rem 1rem' }}>
            Switch to a different account
          </Typography>

          <Stack sx={{ pb: 1 }}>
            <Scrollbar sx={{ maxHeight: 360 }} autoHide={false}>
              {users?.map((merchantUser) => (
                <MenuItem
                  key={merchantUser.id}
                  onClick={() => {
                    onChange(merchantUser.id);
                  }}
                  sx={{ maxWidth: '100%' }}
                >
                  <Typography noWrap>{getMerchantNameById(merchantUser.id)}</Typography>
                  <ListItemIcon sx={{ ml: 1, mr: 0, minWidth: 'auto !important' }}>
                    <BrandedCubesIcon />
                  </ListItemIcon>
                </MenuItem>
              ))}
            </Scrollbar>
          </Stack>
        </>
      )}
    </>
  );
};

export default MerchantSwitcher;
